<template>


  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 111.628 111.628">
    <g id="Fair">
      <g id="Group_29369" data-name="Group 29369">
        <path id="Path_88178" data-name="Path 88178"
          d="M55.814,0a55.814,55.814,0,1,0,55.814,55.814A55.877,55.877,0,0,0,55.814,0M74.735,35.489a6.627,6.627,0,1,1-6.628,6.627,6.628,6.628,0,0,1,6.628-6.627m-37.843,0a6.627,6.627,0,1,1-6.627,6.627,6.627,6.627,0,0,1,6.627-6.627M80.218,75.246H31.41a2.68,2.68,0,0,1,0-5.359H80.218a2.68,2.68,0,1,1,0,5.359"
          :fill="themeColor" />
      </g>
    </g>
  </svg>





</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
